export const root = "r15silxn";
export const statsContainer = "se6axqh";
export const pressContainer = "p1tcc2cp";
export const statsWrapper = "s1weqsgo";
export const title = "tqdxu44";
export const blockTitle = "b11urt9l";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");